<div class="widget-container fluid-height stf-users">
  <div class="heading">
    <i class="fa fa-user"></i>
    <span translate>User list</span>
    <button class="btn btn-primary-outline pull-right btn-sm" style="--bs-btn-hover-bg:#d3d4d5;" title="Add a new user"
      (click)="showCreate()">
      <i class="fa fa-plus fa-fw"></i>
    </button>
    <a class="pull-right btn btn-sm">
      <i class="fa fa-question-circle fa-fw" tooltip-placement="left"
      title="Users are created by Administrators. They are given specific privileges so users can access pages accordingly. Administrators can add/edit/delete and update password for users."></i>
      <!-- uib-tooltip="{{'More about Users' | translate}}"  -->
    </a>
  </div>
  <div class="widget-content padded">
    <div ng-if="users.length">

      <ul class="list-group user-list">
        <!-- //after click show showCreateUser************************************************************** -->
        @if (showCreateUser) {
          <li class="list-group-item"
            style="box-shadow: 0 0 10px 5px rgba(0, 0, 255, 0.5);; border-radius: 0.375rem;padding-bottom: 1.75rem;">
            <div class="user">
              <div class="heading">
                <i class="fa fa-user"></i>
                <span translate>{{"Create new user" | translate}}</span>
              </div>
              <div class="form-inline" name="userForm" style="flex-direction: column;">
                <div class="form-group user-creation">
                  <label class="user-list-label" translate>{{"Name" | translate}}</label>
                  <input class="form-control input-sm" type="text" [(ngModel)]="tmpEnv.userName"
                    (blur)="checkNameValidity()" required title="Punctuation and special characters are not allowed!">
                </div>
                <div class="form-group user-creation">
                  <label class="user-list-label" translate>{{"Email" | translate}}</label>
                  <input class="form-control input-sm" type="text" [(ngModel)]="tmpEnv.userEmail "
                    (blur)="checkEmailValidity()" autocomplete="new-password" required>
                </div>
                <div class="form-group user-creation">
                  <label class="user-list-label" translate>{{"Password" | translate}}</label>
                  <input class="form-control pass input-sm" [type]="showPassword?'text':'password'"
                    [(ngModel)]="tmpEnv.password " (blur)="checkPasswordValidity()" autocomplete="new-password" required
                    title="Password's Length must be >=8">
                  <button type="button" [title]="showPassword?'Hide Password':'Show Password'" class="toggle-password"
                    (click)="togglePasswordVisibility()">
                    <i [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                  </button>
                </div>
                <div class="form-group user-creation">
                  <label class="user-list-label" translate>{{"Key Name" | translate}}</label>
                  <input class="form-control input-sm" type="text" [(ngModel)]="keyName" required>
                </div>
                <div class="form-group user-save">
                <button class="btn btn-sm btn-primary" style="width: 45px;
                      padding: 0px; left: 16.5em;position:relative ;" type="button" (click)="createUser()"
                    [disabled]="!isFormValid">
                    <span translate>{{"Save" | translate}}</span>
                  </button>
                </div>
              </div>
            </div>
            <!-- <div class="password">
            <div class="heading">
              <i class='fa fa-unlock-alt'></i>
              <span translate>Create/Update Password</span>
            </div>
            <div class="form-group user-creation">
              <label class="user-list-label" translate>Email</label>
              <select id="mySelect" class="btn-p" style="margin-left: 1rem;width: 14.76%; border-radius: 0.375rem;"
                (change)="onChange($event)">
                <option value="" selected>Select Email</option>
                <option *ngFor="let userbyemail of  usersListByemail " [value]="userbyemail" autocomplete="off">
                {{ userbyemail }}</option>
              </select>
              <label for="password" style="margin-left: 25px;">Password</label>
              <input type="fieldTextType ? 'text' : 'password'" [(ngModel)]="passwordByAdmin" autocomplete="off"
                style="border-radius: 0.375rem;">
              <button class="btn btn-sm btn-primary" style="width: 45px;    margin-left: 25px;
                    padding: 0px;" type="button" (click)="SavePassword()">
                <span translate>Save</span>
              </button>
            </div>
          </div> -->
        </li>
      }
      <hr>
        <li class="list-group-item" style="margin: 1vh;">
          <div class="user-line user-actions">
            <div class="form-inline user-header">
              <!-- <div class="form-group" style="display: flex;">
              <i class="fa fa-search" id="search"></i>
              <input type="text" class="form-control input-field" id="search-text" aria-describedby="search-text" [(ngModel)]="searchText" placeholder="Search users" class="col-mg-3 m-2 float-right searchGroup" autofocus autocomplete="off">

              <select id="userList" [(ngModel)]="userPageSize" >
                <option *ngFor="let data of userPerPageOptions" value="{{data.value}}">{{data.name}}</option>
              </select>
              <mat-paginator
                class="my-pagination"
                [length]="totalItems"
                [pageSize]="itemsPerPage"
                [pageIndex]="currentPage - 1"
                [pageSizeOptions]="[5, 10, 25, 50]"
                (page)="handlePageChange($event)">
              </mat-paginator>
            </div> -->

            <div class="col-4 col-md-4">
              <app-pagination [totalItems]="users.length" [itemsPerPage]="userPerPageSize" [itemsSearch]="search"
                (searchedData)="onSearch($event)" (itemPerPageData)="onItemPerPageChange($event)"
                (nextPageChange)="onNextPageChange($event)">
              </app-pagination>
            </div>

            <button class="btn btn-xs btn-danger pull-right" type="button" tabindex="Remove"
              title="Remove the user selection"
              ng-disabled="!filteredUsers.length || (filteredUsers.length === 1 && filteredUsers[0].privilege === 'admin')"
              (click)="removeUsers(search,filteredUsers,confirmRemove.value)">
              <i class="fa fa-trash-o"></i>
              <span translate>{{"Remove All" | translate}}</span>
            </button>

            <!-- <button class="btn btn-xs btn-success pull-right" type="button" id="confirmRemove"
            (click)="confirmRemove.value = !confirmRemove.value"
            title="Enable/Disable confirmation for device removing">
            <i *ngIf="confirmRemove.value" class="fa fa-lock"></i>
            <i *ngIf="!confirmRemove.value" class="fa fa-unlock"></i>
            <span translate>Confirm remove</span>
          </button> -->

          <!-- <button class="btn btn-xs btn-danger-outline pull-right" type="button" id="Filters"
          tooltip-placement="top" tooltip-popup-delay="500" (click)="showFilters = !showFilters"
          [ngClass]="{'btn-outline-primary': !showFilters, 'btn-primary': showFilters}">
          <i class="fa" [ngClass]="{'fa-filter': !showFilters, 'fa-trash-o': showFilters}"></i>
          <span translate>Filters</span>
        </button> -->
        <!-- <button class="btn btn-xs pull-right btn-primary" type="button" id="Filters" tooltip-placement="top"
        tooltip-popup-delay="500" (click)="showFilters = !showFilters" [ngClass]="{}" style="color: white;"
        title="Set filters for user removing">
        <i [ngClass]="'fa fa-filter'" style="color: white;"></i>
                 [ngClass]="{'fa-filter': !showFilters, 'fa-trash-o': showFilters} -->
              <!-- <span translate style="color: white;">Filters</span>
              </button> -->

              <button class="btn btn-xs btn-primary-outline pull-right" type="button" id="showDefaultGroupsQuotas"
                (click)="this.showDefaultGroupsQuotas = !this.showDefaultGroupsQuotas;initTemporaryDefaultQuotas()"
        ng-class="{'btn-primary-outline': !showDefaultGroupsQuotas, 'btn-primary': showDefaultGroupsQuotas}"
        title="Set group quotas for new users" style="--bs-btn-hover-bg: #d3d4d5;">
        <i class="fa fa-object-group"></i>
        <span translate>{{"Default Groups Quotas" | translate}}</span>
      </button>
      <button class="btn btn-xs btn-primary-outline pull-right" type="button" id="Contact"
        title="Write an email to the user selection" ng-disabled="!filteredUsers.length" (click)="mailTo()"
        tooltip-placement="top" tooltip-popup-delay="500" title="Write an email to the user selection"
        style="--bs-btn-hover-bg: #d3d4d5;">
        <i class="fa fa-envelope-o"></i>
        <span translate>{{"Contact Users" | translate}}</span>
      </button>

      <!-- <button class="btn btn btn-light contact-owner pull-right" type="button "(click)="mailTo()">
      <i class="fa fa-envelope-o"></i>
      <span translate>Contact Users</span>
    </button> -->
  </div>
</div>
</li>
<hr>

  <!-- //after click fliter********************************* -->
  <!-- <li class="list-group-item" *ngIf="showFilters">
  <div class="user-line" style="margin-top: 10px;">
    <div>
      <button class="btn btn-danger bt-sm" (click)="removeFilters()" style="margin: 1em;">
        <i class="fa fa-trash-o"></i>
        <span>Removing filters</span>
      </button>
    </div>

    <div class="col-md-2">
      <label title="Filter on user group ownership"><span class="text-danger">*</span>Group Owner</label>&nbsp;
      <select [(ngModel)]="removingFilters.groupOwner">
        <option *ngFor="let option of removingFilterOptions" value="{{option}}">{{option}}</option>
      </select>
    </div>
  </div>
</li> -->
@if (showFilters) {
  <hr>
  }
  <!-- after click DefaultQuresgroup ************************************-->
  @if (showDefaultGroupsQuotas) {
    <li class="list-group-item">
      <div class="user-line">
        <div class="heading">
          <i class="fa fa-object-group"></i>
          <span translate>{{"Default groups quotas" | translate}}</span>
        </div>
        <div class="form-inline user-default-quotas-items" name="dafaultQuotasForm">
          <div class="form-group user-default-quotas-item">
            <label class="user-list-label" translate>{{"Number of groups" | translate}}</label>
            <input class="form-control input-sm" type="number" min="0" [(ngModel)]="tmpEnv.defaultGroupsNumber"
              (ngModelChange)="GroupsQuotasDefaultValueChnage()" required>
          </div>
          <div class="form-group user-default-quotas-item">
            <label class="user-list-label">{{"Total duration of groups" | translate}} (ms)</label>
            <input class="form-control input-sm" type="number" min="0" [(ngModel)]="tmpEnv.defaultGroupsDuration"
              (ngModelChange)="GroupsQuotasDefaultValueChnage()" required>
          </div>
          <div class="form-group user-default-quotas-item">
            <label class="user-list-label" translate>{{"Number of repetitions per group" | translate}}</label>
            <input class="form-control input-sm" type="number" min="0" [(ngModel)]="tmpEnv.defaultGroupsRepetitions"
              (ngModelChange)="GroupsQuotasDefaultValueChnage()" required>
          </div>
          <div class="form-group user-default-quotas-save" style="margin-top: 5px;">
            <button class="btn btn-sm btn-primary" tooltip-enable="tmpEnv.defaultQuotasTooltip"
              tooltip-placement="top" tooltip-popup-delay="500" (click)="updateDefaultUserGroupsQuotas()"
              [disabled]="saveDefaultButtonDisable">
              <span translate>{{"Save" | translate}}</span>
            </button>
          </div>
        </div>
      </div>
    </li>
  }
  @if (showDefaultGroupsQuotas) {
    <hr>
    }
    @for (user of  users | search: search| paginate: { itemsPerPage: userPerPageSize, currentPage: page }; track user) {
      <li class="list-group-item" let i="index"
        id="userdata">
        <div class="user-line user-actions" style="margin-top: 10px;">
          <i class="fa fa-user fa-2x fa-fw user-list-icon"></i>
          <div class="user-list-details selectable">
            <a class="user-list-name" href="mailto:{{user.email}}">{{user.name}}</a>
            <div class="user-list-id " style="font-size: 12px;display: flex; align-items: baseline;">
              <span translate>{{"Email:" | translate}}</span>
              <span style="width: 200px; display: inline-block;">{{user.email}}</span>
              <span translate style="margin-left: 20px;">Privilege:</span>
              <span style="width: 100px; display: inline-block;">{{user.privilege}}</span>
            </div>
          </div>
          <button class="btn btn-xs btn-danger-outline pull-right" type="button" (click)="remove(user.email)"
            [disabled]="user.privilege === 'admin'" style="background-color: #DC3545; color: white;">
            <i class="fa fa-trash-o"></i>
            <span translate style="margin-left: 3px;">{{"Remove" | translate}}</span>
          </button>
          <button class="btn btn-xs btn-primary-outline pull-right" type="button"
            (click)="GroupsQuotas=!GroupsQuotas ;initTemporaryQuotas(user)"
            [ngClass]="{'option-button-outline': !user.isGroupsQuotasClicked, 'option-button': user.isGroupsQuotasClicked}"
            style="color: rgb(51, 98, 228); --bs-btn-hover-bg:#d3d4d5">
            <i class="fa fa-object-group"></i>
            <span translate style="margin-left: 3px;">{{"Groups Quotas" | translate}}</span>
          </button>
          @if (user.privilege =='user') {
            <button class="btn btn-xs btn-success pull-right" type="button"
              (click)="enableAppInstall(user.email)">
              <i class="fa fa-check-square"> </i>
              <span translate style="margin-left: 3px">{{"Enable App Install" | translate}}</span>
            </button>
          }
          @if (user.privilege =='user') {
            <button class="btn btn-xs btn-danger-outline pull-right" type="button"
              (click)="disableAppInstall(user.email)" style="color: red; --bs-btn-hover-bg:#d3d4d5">
              <i class="fa fa-times"></i>
              <span translate style="margin-left: 3px">{{"Disable App Install" | translate}}</span>
            </button>
          }
          @if (user.privilege =='user') {
            <button (click)="toggleLock(user)"
              [ngClass]="user.profileActiveStatus ? 'btn btn-primary pull-right':'btn btn-danger pull-right'">
              <i class="fa" [ngClass]="user.profileActiveStatus ? 'fa-unlock' : 'fa-lock'" aria-hidden="true"></i>
              {{ user.profileActiveStatus ? 'Unlocked' : 'Locked' }}
            </button>
          }
          @if (user.isGroupsQuotasClicked) {
            <ul class="GroupsQuotas">
              <li class="list-group">
                <div class="heading user-action-body ">
                  <i class="fa fa-object-group"></i>
                  <span translate style="margin-left: 3px;">{{"Groups Quotas" | translate}}</span>
                </div>
                <div class="form-inline" name="quotasForm" style="display: flex; margin-top: 15px;">
                  <div class="form-group user-quotas-item" style="margin-right: 7px;">
                    <label class="user-list-label" translate>{{"Number of groups" | translate}}</label>
                    <input class="form-control input-sm" type="number" min="0" ng-max-length="5"
                      [(ngModel)]="user.groupsNumber" (ngModelChange)="GroupsQuotasValueChnage()" required>
                  </div>
                  <div class="form-group user-quotas-item" style="margin-right: 7px;">
                    <label class="user-list-label" translate>{{"Total duration of groups " | translate}}(ms)</label>
                    <input class="form-control input-sm" type="number" min="0" [(ngModel)]="user.groupsDuration"
                      (ngModelChange)="GroupsQuotasValueChnage()" required>
                  </div>
                  <div class="form-group user-quotas-item" style="margin-right: 7px;">
                    <label class="user-list-label" translate>{{"Number of repetitions per group" | translate}}</label>
                    <input class="form-control input-sm" type="number" min="0" [(ngModel)]="user.groupsRepetitions"
                      (ngModelChange)="GroupsQuotasValueChnage()" required>
                  </div>
                  <div>
                    <button type="button" (click)="updateUserGroupsQuotas(user)" [disabled]="saveButtonDisable"
                      [ngStyle]="{ 'background-color': buttonColor }" style="padding: 2px;
                             color: white;
                             margin-right: -px;
                             margin-left: 55px;
                             border-radius: 5px;
                             width: 50px;">
                      <span translate>{{"Save" | translate}}</span>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          }
        </div>
        <hr>
        </li>
      }
    </ul>
  </div>
</div>
</div>
<!-- Template &*****************************************-->
<ng-template #delete_user let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to delete this user?" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="removeUser()">{{"Yes, Proceed" | translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #delete_all_user let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to delete all users?" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="removeUsers()">{{"Yes, Proceed" | translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #alert_message let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{alertMessage | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-primary" (click)="cancelRequest()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #created_User let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"User is Succesfully added" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-primary" (click)="cancelRequest()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>


<ng-template #fliter let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Please change the 'Removing filters' option to 'False' or 'Any'" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-primary" (click)="cancelRequest()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>

</ng-template>

<ng-template #created_Password let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Password is Succesfully updated" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-primary" (click)="cancelRequest()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #Duplicate_Password let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Entered password same as current password" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-primary" (click)="cancelRequest()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #Duplicate_User let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"User with the same Email already exists!" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-primary" (click)="cancelRequest()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>

</ng-template>
<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>


<ng-template #blockedUser let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to block this user?" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="BlockedUser()">{{"Yes, Proceed" | translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancel()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>
<ng-template #unblockedUser let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to unblock this user?" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="UnBlockedUser()">{{"Yes, Proceed" |
      translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancel()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>
<ng-template #ProfileStaus let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Succesfully updated" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-primary" (click)="cancel()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>